import Header from "./components/header/Header";
import Home from "./page/Home";


function App() {
    return (
        <div className="container">
            <Header />
            <Home />
        </div>
    );
}

export default App;